import styled from 'styled-components/macro';


export const StyledHouseTypePrice = styled.div`
    display:flex;
    justify-content:center;
    flex-direction:column;
    align-items:center;
    flex-wrap:wrap;
`;

export const Price = styled.div`
    font-size:1.5rem;
    color: #047961;
`;


export const Title = styled.h3`
    font-size: 0.75rem;
    color: #595959;
    font-weight:normal;
`;

export const Image = styled.img`
    max-width:100%;
    height:auto;
    max-height:40px;
`;